import { useNextAppState } from '../../state/store'

export const useNextAppTranslationState = () =>
  useNextAppState(state => state.i18n)
